import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
// import NotifyMessage from "../../Others/NotifyMessage";
import { AllCustomersUploads } from "../../FetchAPI";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import { useAuth } from "../../../Store/AuthContext";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import LinkIcon from "@mui/icons-material/Link";

// import "react-fancybox/lib/fancybox.css";
const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
// const userID = localStorage.getItem("userid");

export default function CustomersUploads({ leadID }) {
  // const navigate = useNavigate();
  const { userID, RendomTokenfetch, userRoll } = useAuth();

  const [uploadData, setUploadData] = useState([]);

  const [openLinkModal, setOpenLinkModal] = useState(false);
  const [linkInput, setLinkInput] = useState("");
  const linkInputRef = useRef(null);

  const openModal = () => {
    setOpenLinkModal(true);
    setTimeout(() => {
      linkInputRef.current?.focus();
    }, 100); // wait for modal to render
  };

  const fetchUploadedFiles = useCallback(async () => {
    const data = await AllCustomersUploads(RendomTokenfetch, leadID, userRoll);
    setUploadData(data);
  }, [RendomTokenfetch, leadID, userRoll]);

  useEffect(() => {
    fetchUploadedFiles();
  }, [fetchUploadedFiles]);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);
  // console.log(uploadData);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    event.preventDefault();

    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    let fdata = new FormData();
    fdata.append("lead_id", leadID);
    fdata.append("userid", userID);
    fdata.append("role_id", userRoll);
    fdata.append("file", fileInputRef.current.files[0]);
    try {
      await axios
        .post(`${WebsiteAPIurl}userFileUpload`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (leadID) {
            if (response.data.Status === "0") {
              NotifyMessageNoReload(response.data.message, "danger");
            }
            if (response.data.Status === "1") {
              fetchUploadedFiles();
              NotifyMessageNoReload(response.data.message, "success");
            }
          } else {
            // console.log(response.data);
          }
        });
    } catch (err) {
      setError(err.message);
      // console.error('Error:', err.response ? err.response.data : err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLinkSubmit = async (event) => {
    event.preventDefault();
    if (!linkInput)
      return NotifyMessageNoReload("Link cannot be empty", "danger");

    setLoading(true);
    try {
      let fdata = new FormData();
      fdata.append("lead_id", leadID);
      fdata.append("userid", userID);
      fdata.append("role_id", userRoll);
      fdata.append("image_url", linkInput);

      const res = await axios.post(`${WebsiteAPIurl}urlFileUpload`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.Status === "1") {
        fetchUploadedFiles();
        NotifyMessageNoReload(res.data.message, "success");
        setLinkInput("");
        setOpenLinkModal(false);
      } else {
        NotifyMessageNoReload(res.data.message, "danger");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (error) {
  }

  return (
    <>
      <div className="customerDocument">
        <div className="SectionBoxintro">
          <h4 className="p-0">My Uploaded Documents</h4>

          <div className="uploadedbtn" style={{ display: "flex", gap: "10px" }}>
            <Tooltip title="Upload Document" placement="top" arrow>
              <button className="DefaultHoverbtn" onClick={handleButtonClick}>
                <CameraAltIcon style={{ marginRight: "6px" }} />
                Upload Document
              </button>
            </Tooltip>

            <Tooltip title="Upload from Link" placement="top" arrow>
              <button className="DefaultHoverbtn" onClick={openModal}>
                <LinkIcon style={{ marginRight: "6px" }} />
                Link
              </button>
            </Tooltip>
          </div>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        <Dialog open={openLinkModal} onClose={() => setOpenLinkModal(false)}>
          <DialogTitle>Upload Document from Link</DialogTitle>
          <DialogContent>
            <TextField
              inputRef={linkInputRef}
              autoFocus
              margin="dense"
              label="Enter File URL"
              fullWidth
              variant="outlined"
              value={linkInput}
              onChange={(e) => setLinkInput(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenLinkModal(false)} color="error">
              Cancel
            </Button>
            <Button onClick={handleLinkSubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <div className="customerdocumetnview">
          <div className="orderleadtable" style={{ overflowX: "auto" }}>
            <table className="default-table table-border manage-job-table customerdocumetnviewtable">
              <thead>
                <tr>
                  <th>Sr.no.</th>
                  <th>Document Name</th>
                  <th>Date</th>
                  <th>View</th>
                </tr>
              </thead>

              <tbody>
                {uploadData.length > 0 ? (
                  uploadData.map((uplValue, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>Document {index + 1}</td>
                      <td>{uplValue.create_date}</td>
                      <td>
                        <Tooltip title="View" placement="right" arrow>
                          <Link
                            to={`${uplValue.storage_url}/${uplValue.file_name}`}
                            data-fancybox
                            data-caption="Customer Uploaded Documents"
                          >
                            <i
                              className="text-primary fa fa-eye"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No documents found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
